import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { IDatePickerConfig, DatePickerComponent } from 'ng2-date-picker';

@Component({
  selector: 'app-date-time-picker',
  templateUrl: './date-time-picker.component.html',
  styleUrls: ['./date-time-picker.component.scss'],
})
export class DateTimePickerComponent implements OnInit {

  constructor() { }

  @Input() class: string;
  @Input() mode: string;
  @Input() date: number;
  dateOld: number;

  @Output() dateChange = new EventEmitter<number>();

  @ViewChild('dayPicker') datePicker: DatePickerComponent;

  open() { this.datePicker.api.open(); }
  close() { this.datePicker.api.close(); }

  dateTime: moment.Moment;
  init: boolean = false;

  formatDate: string;
  dateTimeConfig: IDatePickerConfig;

  ngOnInit(): void {
    this.checkFormat();

    this.dateOld = this.date;
    this.dateTime = moment(this.date);
    this.init = true;
  }

  checkFormat() {
    switch (this.mode) {
      case 'day': {
        this.formatDate = "DD.MM.YYYY";
        break;
      }
      case 'daytime': {
        this.formatDate = "DD.MM.YYYY HH:mm";
        break;
      }
      case 'time': {
        this.formatDate = "HH:mm";
        break;
      }
      case 'month': {
        this.formatDate = "DD.MM.YYYY HH:mm";
        break;
      }
      default: {
        this.formatDate = "DD.MM.YYYY HH:mm";
        break;
      }
    }
    this.configInit();
  }

  configInit(){
    this.dateTimeConfig = {
      locale: moment.locale('ru'),
      firstDayOfWeek: 'mo',
      showTwentyFourHours: true,
      format: this.formatDate
    }
  }

  onChangeDatePicker(model: number) {
    this.date = moment(model).valueOf();
    this.dateChange.emit(this.date);
  }

  ngOnChanges() {
    if (this.init && this.date != this.dateOld) { // Если компонент выполнил ngOnInit и произошло изменение даты (number)
      this.dateTime = moment(this.date);
    }
  }
}
